export default __webpack_public_path__ + "static/media/prestamo.58a4246e.png";